// AgentVerse/client/ui/ProjectDocumentation.js
import { ComponentBase } from "../core/ComponentBase.js";

export class ProjectDocumentation extends ComponentBase {
    constructor(config) {
        super(config);
        this.docManager = null;
        this.currentProjectId = null;
        this._boundHandleProjectSelected = this.handleProjectSelected.bind(this);
    }

    async initialize() {
        await super.initialize();
        // Register the listener FIRST. This is good practice.
        this.appClient.events.local.on('projectSelected', this._boundHandleProjectSelected);
    }
    
    async initAfterLogin() {
        // Actively check for an already-selected project.
        const selectedProject = this.appClient.getSharedData('selectedProject');
        // Call the handler to initialize the component with the current project, if any.
        await this.handleProjectSelected({ projectData: selectedProject });
    }

    async handleProjectSelected({ projectData }) {
        const newProjectId = projectData ? projectData._id : null;
        
        // If project hasn't changed, do nothing.
        if (this.currentProjectId === newProjectId) {
            return;
        }

        // Update the current project state.
        this.currentProjectId = newProjectId;
        this.log.info(`ProjectDocumentation: Project changed to ${this.currentProjectId || 'None'}. Rebuilding DocumentManager.`);

        // If a DocumentManager instance already exists, DESTROY IT COMPLETELY.
        if (this.docManager) {
            this.docManager.destroy();
            this.docManager = null;
        }

        // If a new project is selected, create a brand new document workspace root.
        if (this.currentProjectId) {
            this.docManager = await this.createManagedComponent('DocumentWorkspaceManager', null, {
                instanceId: `project-documentation-manager-${this.currentProjectId}`, // Make instanceId unique to project
                contextId: this.currentProjectId,
                contextType: 'project',
                syncProjectContext: false,
                provider: this.config.provider || 'kbmWorkspace'
            });
        }
        
        // Re-render this component's container to show either the new DocumentManager or the placeholder.
        if (this.container?.isConnected) {
            await this.render();
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'project-documentation-wrapper h-100';
        }
        this.container.innerHTML = '';

        if (this.currentProjectId && this.docManager) {
            this.container.appendChild(await this.docManager.render());
        } else {
            const placeholder = document.createElement('div');
            placeholder.className = 'alert alert-info text-center m-3';
            placeholder.setAttribute('role', 'alert');
            placeholder.innerHTML = `<i class="bi bi-info-circle-fill me-2"></i> ${this.t('Please select a project to manage its documentation.')}`;
            this.container.appendChild(placeholder);
        }

        return this.container;
    }

    destroy() {
        this.appClient.events.local.off('projectSelected', this._boundHandleProjectSelected);
        this.docManager?.destroy();
        this.docManager = null;
        super.destroy();
    }
}
